import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declarant } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useDuplicateDeclarant = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (declarantData: Partial<Declarant>) => {
      await request({
        path: `declarant/add`,
        method: 'POST',
        authenticate: true,
        dataObject: declarantData,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-declarants'] });
      toast.success('Declarant duplicated successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error duplicating declarant!');
    },
  });
};
